import { gql } from "@apollo/client";

import { ADMIN_FIELDS, TENANT_FIELDS } from "./fragments";

export const EDIT_TENANT_FEATURE_FLAGS = gql`
  ${TENANT_FIELDS}
  mutation tenantEditFeatureFlags($featureFlags: TenantFeatureFlagsInput!) {
    tenantEditFeatureFlags(newFeatureFlags: $featureFlags) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_DEFAULT_FEATURE_FLAGS = gql`
  ${TENANT_FIELDS}
  mutation tenantEditFeatureFlagsWithDefaults(
    $featureFlags: TenantFeatureFlagsWithDefaultsInput!
  ) {
    tenantEditFeatureFlagsWithDefaults(newFeatureFlags: $featureFlags) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_NAME = gql`
  ${TENANT_FIELDS}
  mutation tenantEditName($newName: String!) {
    tenantEditName(newName: $newName) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_NUMBER_ROTATION_THRESHOLD = gql`
  ${TENANT_FIELDS}
  mutation tenantEditNumberRotationThreshold($newRotationThreshold: Int) {
    tenantEditNumberRotationThreshold(
      newRotationThreshold: $newRotationThreshold
    ) {
      ...TenantFields
    }
  }
`;

export const ENABLE_TENANT_SUBACCOUNTS = gql`
  ${TENANT_FIELDS}
  mutation subaccountsEnable {
    subaccountsEnable {
      ...TenantFields
    }
  }
`;

export const LIST_ALL_ADMINS = gql`
  ${ADMIN_FIELDS}
  query listAllAdmins($includeDeleted: Boolean, $includeInvited: Boolean) {
    listAdmins(
      includeDeleted: $includeDeleted
      includeInvited: $includeInvited
    ) {
      ...AdminFields
    }
  }
`;

export const ADD_TENANT_OWNER = gql`
  ${ADMIN_FIELDS}
  mutation tenantOwnerPromote($adminId: ID!) {
    tenantOwnerPromote(adminId: $adminId) {
      ...AdminFields
    }
  }
`;

export const REMOVE_TENANT_OWNER = gql`
  ${ADMIN_FIELDS}
  mutation tenantOwnerDelete($adminId: ID!, $deleteAllMemberships: Boolean!) {
    tenantOwnerDelete(
      adminId: $adminId
      deleteAllMemberships: $deleteAllMemberships
    ) {
      ...AdminFields
    }
  }
`;

export const EDIT_TENANT_CSV_UPLOAD_LIMIT = gql`
  ${TENANT_FIELDS}
  mutation tenantEditCsvUploadLimit($newLimitMb: Int, $newLimitRows: Int) {
    tenantEditCsvUploadLimit(
      newLimitMb: $newLimitMb
      newLimitRows: $newLimitRows
    ) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_OUTBOUND_POOL_SIZE = gql`
  ${TENANT_FIELDS}
  mutation tenantEditOutboundPoolSize($newOutboundPoolSize: Int) {
    tenantEditOutboundPoolSize(newOutboundPoolSize: $newOutboundPoolSize) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_APPROVAL_REQUIRED = gql`
  ${TENANT_FIELDS}
  mutation tenantEditApprovalRequired(
    $approval_requirement: ApprovalRequirement!
    $voicemail_allowed: Boolean!
    $confirmationTextAtTimeOfUpdate: String!
    $approverRole: String
  ) {
    tenantEditApprovalRequired(
      approval_requirement: $approval_requirement
      voicemail_allowed: $voicemail_allowed
      confirmationTextAtTimeOfUpdate: $confirmationTextAtTimeOfUpdate
      approverRole: $approverRole
    ) {
      ...TenantFields
    }
  }
`;

export const DEACTIVATE_TENANT = gql`
  ${TENANT_FIELDS}
  mutation tenantDeactivate {
    tenantDeactivate {
      ...TenantFields
    }
  }
`;

export const REACTIVATE_TENANT = gql`
  ${TENANT_FIELDS}
  mutation tenantReactivate {
    tenantReactivate {
      ...TenantFields
    }
  }
`;

// CROSS TENANT OPERATIONS

// These are for use only by the staff admin UI.

// We don't use TENANT_FIELDS for cross-tenant queries because we can't resolve
// any related objects (e.g. default subaccount) due to the
// automatically-applied tenant scoping
export const LIST_TENANTS = gql`
  query listTenants {
    listTenants {
      name
      slug
      deactivatedAt
    }
  }
`;

export const CREATE_TENANT = gql`
  mutation tenantCreate(
    $name: String!
    $slug: String!
    $ownerFullName: String
    $ownerEmail: String
  ) {
    tenantCreate(
      name: $name
      slug: $slug
      ownerFullName: $ownerFullName
      ownerEmail: $ownerEmail
    ) {
      name
      slug
      deactivatedAt
    }
  }
`;
